import { useClassName } from './useClassName';
import { styleRule } from './styleRule';
import { LooseProps, splitProps } from './props';

export function Accordion(props: LooseProps) {
  const { sx, className, children, ...rest } = props;
  const { system, dom } = splitProps(rest);
  const {
    className: resolvedClass,
    css,
    styleId,
  } = useClassName(
    [
      {
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
        color: 'inherit',
        borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
        '&::before': { display: 'none' },
        ...system,
      },
      sx,
    ],
    undefined,
    className,
  );
  return (
    <>
      {styleRule(styleId, css)}
      <details {...dom} className={resolvedClass}>
        {children}
      </details>
    </>
  );
}

export function AccordionSummary(props: LooseProps) {
  const { sx, className, children, expandIcon, ...rest } = props;
  const { system, dom } = splitProps(rest);
  const {
    className: resolvedClass,
    css,
    styleId,
  } = useClassName(
    [
      {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        minHeight: '48px',
        padding: '0 16px',
        cursor: 'pointer',
        listStyle: 'none',
        '&::-webkit-details-marker': { display: 'none' },
        ...system,
      },
      sx,
    ],
    undefined,
    className,
  );
  return (
    <>
      {styleRule(styleId, css)}
      <summary {...dom} className={resolvedClass}>
        <span style={{ flex: 1 }}>{children}</span>
        {expandIcon ? (
          <span style={{ display: 'inline-flex', color: 'inherit' }}>{expandIcon}</span>
        ) : null}
      </summary>
    </>
  );
}

export function AccordionDetails(props: LooseProps) {
  const { sx, className, children, ...rest } = props;
  const { system, dom } = splitProps(rest);
  const {
    className: resolvedClass,
    css,
    styleId,
  } = useClassName([{ padding: '8px 16px 16px', ...system }, sx], undefined, className);
  return (
    <>
      {styleRule(styleId, css)}
      <div {...dom} className={resolvedClass}>
        {children}
      </div>
    </>
  );
}
